export const LABEL_MAPPINGS = {
  employmentStatus: {
    UNEMPLOYED: 'Unemployed',
    EMPLOYED: 'Full-Time Employed',
    SELFEMPLOYED: 'Self-Employed',
    RETIRED: 'Retired',
    STUDENT: 'Student',
    OTHER: 'Other',
    PART_TIME: 'Part-Time Employed',
    CONTRACTOR: 'Contractor',
    DISABLED: 'On disability',
  },
  tenure: {
    LESS_THAN_1_YEAR: 'Less than 1 year',
    MORE_THAN_10_YEARS: 'More than 10 years',
  },
  homeOwnershipStatus: {
    RENT: 'Pay rent',
    MORTGAGE: 'Pay a mortgage',
    OWN: 'Fully own',
  },
  dscQuestion: {
    YES: 'Yes',
    NO: 'No',
  },
};

// TODO: Remove or implement inside of agreements component
export const agreementLinks = {
  PrivacyPolicy: {
    link: '%2Fapply%2Fpersonal%2Flegal-agreement%2FPrivacyPolicy',
  },
  SharedTermsOfUse: {
    link: '%2Fapply%2Fpersonal%2Flegal-agreement%2FSharedTermsOfUse',
  },
  PersonalCreditProfileAuth: {
    link: '%2Fapply%2Fpersonal%2Flegal-agreement%2FPersonalCreditProfileAuth',
  },
  SharedElectronicConsent: {
    link: '%2Fapply%2Fpersonal%2Flegal-agreement%2FSharedElectronicConsent',
  },
  ApplicationTermsOfUse: {
    link: '%2Fapply%2Fpersonal%2Flegal-agreement%2FApplicationTermsOfUse',
  },
};

export const HOME_STATUS_OPTIONS = [
  { value: 'RENT', label: LABEL_MAPPINGS.homeOwnershipStatus.RENT },
  { value: 'MORTGAGE', label: LABEL_MAPPINGS.homeOwnershipStatus.MORTGAGE },
  { value: 'OWN', label: LABEL_MAPPINGS.homeOwnershipStatus.OWN },
];

export const HOME_STATUS_EXPENSE_FIELD = {
  RENT: {
    label: 'Monthly Rent Payment',
    helperText: 'Enter just your portion of the rent or $0 if you don’t pay rent.',
  },
  MORTGAGE: {
    label: 'Monthly Mortgage Payment',
    helperText: 'Enter just your portion of the mortgage or $0 if you don’t pay mortgage.',
  },
};

// Don't change this until you have a new field added in WorkInformation.
export const ALL_FIELDS = [
  'employmentStatus',
  'employerName',
  'workPhone',
  'tenure',
  'street',
  'city',
  'state',
  'zip',
  'position',
  'more-work',
];
export const STREET_MAPPING_WI = {
  street: 'workStreet',
  city: 'workCity',
  state: 'workState',
  zip: 'workZipCode',
};
const employmentStatus = ['employmentStatus'];
const selfAndContractor = [...employmentStatus, 'employerName', 'workPhone'];
const incomeAndAgreements = ['income', 'agreements'];

const commonFields = [...selfAndContractor, 'tenure', 'street', 'city', 'state', 'zip'];
const otherStatus = [...employmentStatus, 'more-work'];
export const VALIDATE_FIELDS_BASED_ON_STATUS = {
  EMPLOYED: [...commonFields, 'position'],
  PART_TIME: [...commonFields],
  SELFEMPLOYED: [...selfAndContractor],
  CONTRACTOR: [...selfAndContractor],
  RETIRED: otherStatus,
  STUDENT: otherStatus,
  OTHER: otherStatus,
  DISABLED: otherStatus,
  UNEMPLOYED: otherStatus,
};

// for coborrower we need income & agreements.
export const VALIDATE_FIELDS_BASED_ON_STATUS_WI = {
  ...VALIDATE_FIELDS_BASED_ON_STATUS,
  EMPLOYED: [...VALIDATE_FIELDS_BASED_ON_STATUS.EMPLOYED, ...incomeAndAgreements],
  PART_TIME: [...VALIDATE_FIELDS_BASED_ON_STATUS.PART_TIME, ...incomeAndAgreements],
  SELFEMPLOYED: [...VALIDATE_FIELDS_BASED_ON_STATUS.SELFEMPLOYED, ...incomeAndAgreements],
  CONTRACTOR: [...VALIDATE_FIELDS_BASED_ON_STATUS.SELFEMPLOYED, ...incomeAndAgreements],
  OTHER: [...VALIDATE_FIELDS_BASED_ON_STATUS.OTHER, ...incomeAndAgreements],
};

export const MORE_WORK_OPTIONS = [
  { value: 'RETIRED', label: LABEL_MAPPINGS.employmentStatus.RETIRED },
  { value: 'DISABLED', label: LABEL_MAPPINGS.employmentStatus.DISABLED },
  { value: 'STUDENT', label: LABEL_MAPPINGS.employmentStatus.STUDENT },
  { value: 'UNEMPLOYED', label: LABEL_MAPPINGS.employmentStatus.UNEMPLOYED },
  { value: 'OTHER', label: 'I do something else' },
];

export const WORK_STATUS_OPTIONS = [
  { value: 'EMPLOYED', label: LABEL_MAPPINGS.employmentStatus.EMPLOYED },
  { value: 'PART_TIME', label: LABEL_MAPPINGS.employmentStatus.PART_TIME },
  { value: 'SELFEMPLOYED', label: LABEL_MAPPINGS.employmentStatus.SELFEMPLOYED },
  { value: 'CONTRACTOR', label: LABEL_MAPPINGS.employmentStatus.CONTRACTOR },
  { value: 'OTHER', label: LABEL_MAPPINGS.employmentStatus.OTHER },
];

export const WORK_STATUS = {
  EMPLOYED: 'EMPLOYED',
  PART_TIME: 'PART_TIME',
  SELFEMPLOYED: 'SELFEMPLOYED',
  CONTRACTOR: 'CONTRACTOR',
  OTHER: 'OTHER',
};

export const SSN_ERRORS = {
  PI1_SSN_PRIMARY_REQUIRED: 'PI1_SSN_PRIMARY_REQUIRED',
  PI1_SSN_SECONDARY_REQUIRED: 'PI1_SSN_SECONDARY_REQUIRED',
  PI1_SSN_PRIMARY_SECONDARY_REQUIRED: 'PI1_SSN_PRIMARY_SECONDARY_REQUIRED',
  PI2_SSN_SECONDARY_REQUIRED: 'PI2_SSN_SECONDARY_REQUIRED',
  INVALID_SSN_SECONDARY: 'INVALID_SSN_SECONDARY',
  IDENTICAL_SSN_SECONDARY: 'IDENTICAL_SSN_SECONDARY',
};

export const SSN_ERRORS_MAP = {
  unhappy: [
    SSN_ERRORS.PI1_SSN_PRIMARY_REQUIRED,
    SSN_ERRORS.PI1_SSN_SECONDARY_REQUIRED,
    SSN_ERRORS.PI1_SSN_PRIMARY_SECONDARY_REQUIRED,
  ],
  mismatch: [
    SSN_ERRORS.PI2_SSN_SECONDARY_REQUIRED,
    SSN_ERRORS.INVALID_SSN_SECONDARY,
    SSN_ERRORS.IDENTICAL_SSN_SECONDARY,
  ],
};

export default {
  HOME_STATUS_OPTIONS,
  LABEL_MAPPINGS,
  VALIDATE_FIELDS_BASED_ON_STATUS,
  ALL_FIELDS,
};

export const FLOWS = {
  NEW: 'NEW',
  REPEATS: 'REPEATS',
  REPEATS_NEW: 'REPEATS_NEW',
  ILOC: 'ILOC',
  CREDIT_IN_A_BOX: 'CREDIT_IN_A_BOX',
};

export const STATES = {
  PI1: 'PI1',
  PI2: 'PI2',
  ADD_COBORROWER: 'ADD_COBORROWER',
  ILOC: 'ILOC',
};

export const PRE_APPROVED_TITLE = {
  'preApproved_non-discount': 'You’re pre-approved!*',
  preApproved_coupon: 'Pre-approved with an interest rate discount!*',
  preApproved_ofee: 'Pre-approved with an origination fee discount!*',
};
export const PRE_APPROVED_DISC_WITHOUT_AMT =
  'We use the words "pre-approved," "pre-approval," and other related words to describe a high likelihood of approval based on our evaluation of a person\'s credit profile, which we perform in advance of providing an offer and receiving a request for credit. These descriptions do not mean that your approval is guaranteed. Approval and credit eligibility are not guaranteed. This pre-approved offer does not incorporate or apply to specific loan amounts, APRs, or other loan terms. You received this pre-approved offer based on certain creditworthiness criteria and the income that we have on file for you. If your credit profile or income has changed, your request for credit may be declined. We may decide not to extend credit to you if you fail to provide relevant information. Loans are not available to consumers with pending bankruptcy proceedings. This offer may be accepted only by the person identified in this offer. This offer is not valid with respect to any application that includes another person as a co-applicant. Duplicate offers received as a result of multiple communications to the same person are void, as are multiple acceptances of the same offer.';
//calling it out that this is dependent on PBS implementation
export const ONT_OFEE_BANNER_TITLE = '{{ontDiscEstPercentage}} Origination Fee Discount';
export const ONT_COUPON_BANNER_TITLE = 'Interest Rate Discount';
export const APPLY_WITH_COBORROWER_TEXT = 'Applying with a co-borrower';
export const LBB_TITLE = 'Bundle & Save Discount Applied!';
export const TOP_UP_TITLE = 'Apply for a TopUp™ Loan';
export const CIAB_BANNER_TITLE = 'You’re preselected!*';

export const REPEATS_TYPE = {
  LongForm: 'LONG_FORM',
  Locked: 'LOCKED',
  LC_CIAB_REPEATS: 'CREDIT_IN_A_BOX',
  PreApproved: 'PRE_APPROVED',
  DebtIQ: 'DEBT_IQ',
};

